import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import FieldErrors from 'components/FieldErrors';

export default function Field({
  name,
  label,
  labelClassName,
  className,
  hint,
  hintClassName,
  error,
  serverErrors,
  clientErrors,
  errorClassName,
  children,
  actions,
}) {
  return (
    <div className={classNames('m-b-s', { [className]: className })}>
      {label && (
        <div className="m-b-xxs">
          <label
            className={classNames('dark bold', {
              [labelClassName]: labelClassName,
            })}
          >
            {label}
          </label>
          {hint && (
            <div
              className={classNames('h6', {
                [hintClassName]: hintClassName,
              })}
            >
              {hint}
            </div>
          )}
          {actions}
        </div>
      )}
      {children}
      {name && (
        <FieldErrors
          className={errorClassName}
          name={name}
          errors={serverErrors}
        />
      )}
      {name && (
        <FieldErrors
          className={errorClassName}
          name={name}
          prefixName={false}
          errors={clientErrors}
        />
      )}
      {error && (
        <div
          className={classNames('h6 danger', {
            [errorClassName]: errorClassName,
          })}
        >
          {error}
        </div>
      )}
    </div>
  );
}

Field.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  hint: PropTypes.string,
  hintClassName: PropTypes.string,
  serverErrors: PropTypes.object,
  error: PropTypes.string,
  errorClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
};
